import { useState } from "react";
import {TextButton, Button, FlexBox, Modal, Title, Body, Loader} from "components";
import { useDeleteProjectTeamMutation } from "services/api/api.slice";
import { useDispatch } from "hooks/redux";
import { setNotification } from "services";
import {ProjectTeamProps} from "../../interfaces";


export interface DeleteTeamModalProps {
  projectInstanceId: string;
  onClose: Function;
  onComplete: Function;
  team: ProjectTeamProps;
}

const DeleteTeamModal = ({
  projectInstanceId,
  onClose,
  onComplete,
  team
}: DeleteTeamModalProps) => {
  
  const dispatch = useDispatch();
  
  const [deleteTeam, {isLoading: deleteTeamLoading}] = useDeleteProjectTeamMutation();
  const [isLoading, _isLoading] = useState<boolean>(false);
  const callDeleteTeam = () => {
    _isLoading(true);
    deleteTeam({projectInstanceId: projectInstanceId, team: team})
    .unwrap()
    .then(() => {
      dispatch(
        setNotification({
          type: "success",
          message: `Team successfully deleted`,
        })
      );
      onComplete(team);
    })
    .catch((error: any) => {
      dispatch(
        setNotification({
          type: "error",
          message: `Could not delete team`,
        })
      );
      console.error(error);
    })
    .finally(() => {
      _isLoading(false);
    });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={true} testId="delete-team-modal" onClose={handleClose} disabled={isLoading || deleteTeamLoading}>
      <FlexBox>
        <Title size="large" bold pd="0 0 2rem">
          {`Delete team: ${team.name}`}
        </Title>
        {isLoading || deleteTeamLoading ? (
          <FlexBox align="center" justify="center">
            <Loader active containerHeight="10rem" />
          </FlexBox>
        ) : (
          <>
            <Body size="large" pd="0 0 2rem">
              Warning: This team will be unassigned from any tasks to which they have been assigned.
            </Body>
            <FlexBox row gap="1.5rem" align="center" justify="flex-start">
              <Button testId="submit-delete-team-button" use="primary" onClick={callDeleteTeam} disabled={isLoading || deleteTeamLoading}>
                Delete team
              </Button>
              <TextButton testId="cancel-button" onClick={handleClose} disabled={isLoading || deleteTeamLoading}>
                Cancel
              </TextButton>
            </FlexBox>
          </>
        )}
        
      </FlexBox>
    </Modal>
  );
};

export default DeleteTeamModal;
